import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import Container from "../Container";
import { H2, Copy, Eyebrow } from "../Typography";

const ContentAreaColumns = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colours.lightGrey};
`;

const ContentAreaColumn = styled(Box)`
  &:nth-child(odd) {
    padding-bottom: 20px;
  }

  @media (${({ theme }) => theme.mq.m}) {
    padding-bottom: 0;
    &:nth-child(odd) {
      padding-right: 10%;
      padding-left: 4rem;
      &:before {
        content: "01";
        position: absolute;
        top: 0;
        left: 0;
        font-family: "supply-light";
        font-size: 38px;
        color: ${({ theme }) => theme.colours.lightGrey};
      }
    }
    &:nth-child(even) {
      padding-right: 10%;
    }
  }
`;

const ContentAreaColumnNoIndexNumber = styled(Box)`
  &:nth-child(odd) {
    padding-bottom: 20px;
  }

  @media (${({ theme }) => theme.mq.m}) {
    padding-bottom: 0;

    &:nth-child(even) {
      padding-right: 10%;
    }
  }
`;

const FullWidthWrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function TitleAndTwoColumns({
  eyebrow,
  title,
  description,
  subDescription,
  hideTitle,
  hideIndexNumberDisplay,
  hasBottomMargin,
  hasTopMargin,
  backgroundColour,
}) {
  return (
    <FullWidthWrapper
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        <Box marginTop={[0, 1]} cols={[6, 8, 6]} marginBottom={0.5}>
          {eyebrow && <Eyebrow colour="blue">{eyebrow}</Eyebrow>}
          {!hideTitle && <H2>{title}</H2>}
        </Box>
        <ContentAreaColumns>
          {hideIndexNumberDisplay ? (
            <ContentAreaColumnNoIndexNumber cols={6} marginTop={0.25}>
              <Copy medium>{description}</Copy>
            </ContentAreaColumnNoIndexNumber>
          ) : (
            <ContentAreaColumn cols={6} marginTop={0.25}>
              <Copy medium>{description}</Copy>
            </ContentAreaColumn>
          )}
          <ContentAreaColumn cols={6} marginTop={0.25}>
            <Copy>{subDescription}</Copy>
          </ContentAreaColumn>
        </ContentAreaColumns>
      </Container>
    </FullWidthWrapper>
  );
}

export default TitleAndTwoColumns;
